export default __webpack_public_path__ + "static/media/poster3.7b7206e3.jpg";